import { apiClient } from "./orvalClient";

import { getAsset } from "../generated/asset/asset";
import { getUser } from "../generated/user/user";
import { getVrauth } from "../generated/vrauth/vrauth";
import { getWatchlist } from "../generated/watchlist/watchlist";
import { getOrg } from "../generated/org/org";
import { getImage } from "../generated/image/image";
import { getVideo } from "../generated/video/video";

export const assetApi = getAsset(apiClient);
export const userApi = getUser(apiClient);
export const vrAuthApi = getVrauth(apiClient);
export const watchlistApi = getWatchlist(apiClient);
export const orgApi = getOrg(apiClient);
export const imageApi = getImage(apiClient);
export const videoApi = getVideo(apiClient);

export { apiClient };
